import { MyGardensContainer } from '@modules/my-gardens/containers/my_gardens_container';
import { MyGardens } from '@modules/my-gardens/views/my_gardens_view';
import { createWebNavigateHandler } from '@/src/lib/navigation/createWebAppHandlers';
import { useNavigate } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';

export function GardensScreen() {
  const navigate = useNavigate();
  const onNavigate = useMemo(() => createWebNavigateHandler(navigate), [navigate]);
  const onError = useCallback((message: string) => {
    toast.error(message);
  }, []);

  return <MyGardensContainer View={MyGardens} onNavigate={onNavigate} onError={onError} />;
}
